/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);

    }
  }
  customElements.define('free-shipping', FreeShipping);
}




// if (!customElements.get('free-shipping')) {
//   class FreeShipping extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {

//       const total = parseInt(this.dataset.cartTotal, 10);
//       const amountText = this.querySelector('.free-shipping--text span');

//       this.remainingText = this.querySelector('.free-shipping--text-remaining');
//       this.fullText = this.querySelector('.free-shipping--text-full');

//       const firstMilestone = 2499;
//       const secondMilestone = 2899;

//       let percentage = 0;
//       let message = '';

//       const format =
//         window.theme?.settings?.money_with_currency_format || "₹{{amount}}";

//       if (total < firstMilestone) {
//         // 🔹 Before ₹100 OFF
//         let remaining = firstMilestone - total;

//         message = `Just ${formatMoney(remaining, format)} away from FLAT ₹100 OFF`;
//         percentage = (total / firstMilestone) * 50;

//         this.remainingText.style.display = 'block';
//         this.fullText.style.display = 'none';

//       } else if (total >= firstMilestone && total < secondMilestone) {
//         // 🔹 ₹100 OFF unlocked, moving towards ₹200
//         let remaining = secondMilestone - total;

//         message = `₹100 OFF unlocked · Spend ${formatMoney(remaining, format)} more to get ₹200 OFF`;
//         percentage =
//           50 +
//           ((total - firstMilestone) / (secondMilestone - firstMilestone)) * 50;

//         this.remainingText.style.display = 'block';
//         this.fullText.style.display = 'none';

//       } else {
//         // 🔹 ₹200 OFF unlocked
//         message = `₹200 OFF unlocked · Best deal applied`;
//         percentage = 100;

//         this.remainingText.style.display = 'none';
//         this.fullText.style.display = 'block';
//       }

//       if (amountText) {
//         amountText.innerHTML = message;
//       }

//       this.style.setProperty('--percentage', percentage);
//     }
//   }

//   customElements.define('free-shipping', FreeShipping);
// }
